var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['xd-button',_vm.disabled ? 'disabled' : '' ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.disabled ? null : _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }